import { useState, useEffect } from "react";
import { Table, Button, Alert, Card, Pagination, Spinner } from "react-bootstrap";
import { FaEdit, FaTrash, FaTrashAlt } from "react-icons/fa";
import { Toast, ToastContainer } from 'react-bootstrap';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from "axios";
import TaskModal from "../../components/TaskModal"; 
import { BASE_URL } from "../../constants";
import Layout from "../../components/Layout";
import { useAuth } from "../../Context/AuthContext";
import ConfirmDeleteModal from '../../components/DeleteModal';
const ManageTasksScreen = () => {
  const [tasks, setTasks] = useState([]);
  const [assignedTasks, setAssignedTasks] = useState([]);
   const [infoMessage, setInfoMessage] = useState([]); 
   const [successMessage, setSuccessMessage] = useState("");
   const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingTasks, setLoadingTasks] = useState([]);
  const [error, setError] = useState("");
  const [showAddTaskModal, setShowAddTaskModal] = useState(false);
  const [showEditTaskModal, setShowEditTaskModal] = useState(false);
  const [editTask, setEditTask] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);  // State to control modal visibility
  const [currentTaskId, setCurrentTaskId] = useState(null);
  const [zoomImage, setZoomImage] = useState(null);
  const {user} = useAuth();
  const shelterId = user?.shelter.id;
  const itemsPerPage = 4;
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageAssigned, setCurrentPageAssigned] = useState(1);
const fetchTasks = async () => {
  setLoading(true);
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${BASE_URL}/tasks/shelter/${shelterId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const tasksData = Array.isArray(response.data) ? response.data : [];
    const filteredAssigned = tasksData.filter(task => task && task.assignedTo);

    setAssignedTasks(filteredAssigned);
    if (tasksData.length > 0) {
      setTasks(tasksData);
      setInfoMessage(null);
    } else {
      setTasks([]);
      setAssignedTasks([]);
      setInfoMessage("No tasks available at the moment.");
    }
    setError(null);
  } catch (err) {
    console.error("Error fetching tasks:", err);
    setError("Failed to fetch tasks. Please try again.");
    setInfoMessage(null);
  } finally {
    setLoading(false);
  }
};

  
  useEffect(() => {
    fetchTasks();
  }, [shelterId]);
  
  // Call this when the modal submits a task
  const handleModalSubmit = (newTask) => {
    setTasks((prevTasks) => [...prevTasks, newTask]);
  
    // ✅ If the task is assigned, also update assignedTasks
    if (newTask.assignedTo) {
      setAssignedTasks((prevAssigned) => [...prevAssigned, newTask]);
    }
    fetchTasks();
    setShowAddTaskModal(false);
  };
  
  const handleClearTask = async (taskId) => {
    try {
      setLoadingTasks((prev) => [...prev, taskId]);
  
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${BASE_URL}/tasks/${taskId}/clear`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
  
      setSuccessMessage(response.data.message);
      fetchTasks();
    } catch (err) {
      setError("Failed to clear the task. Make sure it's completed.");
    } finally {
      setLoadingTasks((prev) => prev.filter((id) => id !== taskId)); 
    }
  };


  
  const handleEditTask = async (taskData) => {
    try {
      const token = localStorage.getItem("token");
  
      const response = await axios.put(
        `${BASE_URL}/tasks/${editTask._id}/assign`,
        taskData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      const updatedTask = response.data;
      console.log("Updated Task from backend:", updatedTask);
  
      // Normalize assignedTo to always be an array
      updatedTask.assignedTo = Array.isArray(updatedTask.assignedTo)
        ? updatedTask.assignedTo
        : updatedTask.assignedTo ? [updatedTask.assignedTo] : [];
  
      setTasks((prevTasks) =>
        prevTasks.map((task) =>
          task._id === updatedTask._id ? updatedTask : task
        )
      );
  
      setAssignedTasks((prevAssigned) => {
        const isAssigned = updatedTask.assignedTo.length > 0;
        const alreadyExists = prevAssigned.some((task) => task._id === updatedTask._id);
  
        if (isAssigned && !alreadyExists) {
          return [...prevAssigned, updatedTask];
        } else if (isAssigned && alreadyExists) {
          return prevAssigned.map((task) =>
            task._id === updatedTask._id ? updatedTask : task
          );
        } else {
          return prevAssigned.filter((task) => task._id !== updatedTask._id);
        }
      });
      fetchTasks();
      setShowEditTaskModal(false);
      setEditTask(null);
    } catch (err) {
      setError("Failed to edit task. Please try again.");
    }
  };
  
  
  const handleDeleteTask = async () => {
    try {
      const token = localStorage.getItem("token");
  
      await axios.delete(`${BASE_URL}/tasks/${currentTaskId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      // Update state manually without refetching all tasks
      setTasks((prevTasks) => prevTasks.filter((task) => task._id !== currentTaskId));
      setAssignedTasks((prevAssigned) => prevAssigned.filter((task) => task._id !== currentTaskId));
  
      setShowDeleteModal(false);
      setSuccessMessage("Task deleted successfully.");
  
      // Adjust pagination if current page now has no tasks and currentPage > 1
      const remainingTasksCount = tasks.length - 1; // one task deleted
      const maxPage = Math.ceil(remainingTasksCount / itemsPerPage);
  
      if (currentPage > maxPage && currentPage > 1) {
        setCurrentPage(maxPage);
      }
  
      // Similarly for assigned tasks pagination if needed:
      const remainingAssignedCount = assignedTasks.length - 1;
      const maxPageAssigned = Math.ceil(remainingAssignedCount / itemsPerPage);
  
      if (currentPageAssigned > maxPageAssigned && currentPageAssigned > 1) {
        setCurrentPageAssigned(maxPageAssigned);
      }
  
    } catch (err) {
      setError("Failed to delete task. Please try again.");
    }
  };
  
  // Open the delete modal and set the task ID
  const openDeleteModal = (taskId) => {
    setCurrentTaskId(taskId);
    setShowDeleteModal(true);
  };

 // Pagination logic
 const indexOfLastTask = currentPage * itemsPerPage;
 const indexOfFirstTask = indexOfLastTask - itemsPerPage;
 const currentTasks = tasks.slice(indexOfFirstTask, indexOfLastTask);
 const totalPages = Math.ceil(tasks.length / itemsPerPage);

 const indexOfLastTaskAssigned = currentPageAssigned * itemsPerPage;
 const indexOfFirstTaskAssigned = indexOfLastTaskAssigned - itemsPerPage;
 const currentTasksAssigned = assignedTasks.slice(indexOfFirstTaskAssigned, indexOfLastTaskAssigned);
 const totalPagesTasks = Math.ceil(assignedTasks.length / itemsPerPage);
 
  return (
<Layout>
    <div className="mt-5">
      <h2 className="text-center mb-4 text-primary">Manage Tasks</h2>
      <Button
        variant="cyan"
        onClick={() => setShowAddTaskModal(true)}
        className="mb-3"
      >
        <FontAwesomeIcon icon={faPlus} className="me-2" />
        <span className="small">Add New Task</span>
      </Button>
   
      
          
          
      {loading ? (
      <div className="text-center">
      
      </div>
    ) : tasks.length > 0 ? (
<Card border="light" className="shadow-sm mt-3">
  <Card.Body className="pt-0">
    <div className="table-responsive">
      <Table hover className="user-table align-items-center mt-3">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Task Name</th>
                  <th scope="col">Description</th>
             
                
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentTasks.map((task, index) => (
                  <tr key={task._id}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{task.taskName || '-'}</td>
                    <td>{task.description || '-'}</td>
                    <td>
                      <Button
                        className="me-2 btn-primary btn-sm"
                        onClick={() => {
                          setEditTask(task);
                          setShowEditTaskModal(true);
                        }}
                      >
                        <FaEdit />
                      </Button>
                      <Button
              className="btn-danger btn-sm"
              onClick={() => openDeleteModal(task._id)} 
            >
              <FaTrashAlt />
            </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            </div>

            <Pagination className="mt-3">
  <Pagination.Prev
    onClick={() => setCurrentPage(currentPage - 1)}
    disabled={currentPage === 1}
  >
    Previous
  </Pagination.Prev>

  {[...Array(totalPages)].map((_, index) => (
    <Pagination.Item
      key={index}
      active={index + 1 === currentPage}
      onClick={() => setCurrentPage(index + 1)}
    >
      {index + 1}
    </Pagination.Item>
  ))}

  <Pagination.Next
    onClick={() => setCurrentPage(currentPage + 1)}
    disabled={currentPage === totalPages}
  >
    Next
  </Pagination.Next>
</Pagination>


          </Card.Body>
        </Card>
     ) : null 
}
      {/* Add Task Modal */}
      <TaskModal
        show={showAddTaskModal}
        onHide={() => setShowAddTaskModal(false)}
        task={null}
        setToastMessage={setToastMessage}
       setShowToast={setShowToast}
        onSubmit={handleModalSubmit}
        disabled={loading}
        title="Add New Task"
      />
<ToastContainer position="top-end" className="p-3">
  <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide bg="success">
    <Toast.Body className="text-white">{toastMessage}</Toast.Body>
  </Toast>
</ToastContainer>

      {/* Edit Task Modal */}
      {editTask && (
        <TaskModal
          show={showEditTaskModal}
          onHide={() => setShowEditTaskModal(false)}
          task={editTask}
          onSubmit={handleEditTask}
          setToastMessage={setToastMessage}
          setShowToast={setShowToast}
          title="Edit Task"
        />
      )}
       <ConfirmDeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}  
        onConfirm={handleDeleteTask} 
        itemName="this task"  
      />
    </div>
   <div>
   {loading ? (
     <div className="text-center">
     </div>
   ) :
   assignedTasks.length > 0 ? (
<Card border="light" className="shadow-sm mt-3">
  <Card.Body className="pt-0">
    <div className="table-responsive">
      <Table hover className="user-table align-items-center mt-3">
         <thead>
           <tr> 
             <th scope="col">#</th>
             <th scope="col">Task Name</th>
             <th scope="col">Assigned Refugee</th>
             {/*<th scope="col">Description</th>*/}
             <th scope="col">Due Date</th>
          
             <th scope="col">Status</th>
             <th scope="col">Before Cleaning</th>
             <th scope="col">After Cleaning</th>
             <th scope="col">Actions</th>
           </tr>
         </thead>
         <tbody>
         {currentTasksAssigned.map((task, index) => (
             <tr key={task._id}>
              <td>{(currentPageAssigned - 1) * itemsPerPage + index + 1}</td>
               <td>{task.taskName || '-'}</td>
               <td>
{task.assignedTo
 ? task.assignedTo.firstName && task.assignedTo.lastName
   ? `${task.assignedTo.firstName} ${task.assignedTo.lastName}`
   : task.assignedTo.identifiant
 : "Unassigned"}
</td>

               {/*<td>{task.description}</td>*/}
               <td>{new Date(task.dueDate).toLocaleDateString() || '-'}</td>
            
               <td>
                 <span
                   className={`badge ${
                     task.status === "Completed"
                       ? "bg-success"
                       : task.status === "Pending"
                       ? "bg-warning"
                       : "bg-danger"
                   } text-light`}
                 >
                   {task.status || "No Status"}
                 </span>
               </td>
               <td>
  {task.photoBefore && task.photoBefore.trim() !== "" ? (
    <img
      src={task.photoBefore}
      alt="Before Cleaning"
      className="img-fluid rounded"
      style={{ width: "50px", height: "50px", cursor: "pointer" }}
      onClick={() => setZoomImage(task.photoBefore)}
    />
  ) : (
    "-"
  )}
</td>


<td>
  {task.photoAfter && task.photoAfter.trim() !== "" ? (
    <img
      src={task.photoAfter}
      alt="After Cleaning"
      className="img-fluid rounded"
      style={{ width: "50px", height: "50px", cursor: "pointer" }}
      onClick={() => setZoomImage(task.photoAfter)}
    />
  ) : (
    "-"
  )}
</td>

{zoomImage && (
  <div
    className="modal show fade d-block"
    tabIndex="-1"
    onClick={() => setZoomImage(null)}
    style={{
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
    }}
  >
    <div
      className="modal-dialog modal-dialog-centered"
      onClick={e => e.stopPropagation()}
    >
      <div
        className="modal-content bg-transparent border-0 shadow-none"
      >
        <div className="modal-body text-center p-0">
          <img
            src={zoomImage}
            alt="Zoomed"
            className="img-fluid rounded"
           
          />
        </div>
      </div>
    </div>
  </div>
)}


<td>
  <Button
    size="xs"
    disabled={task.status !== "Completed" || loadingTasks.includes(task._id)}
    onClick={() => handleClearTask(task._id)}
  >
    {loadingTasks.includes(task._id) ? (
      <>
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          className="me-2"
        />
       
      </>
    ) : (
      "Approve"
    )}
  </Button>
</td>

             </tr>
           ))}
         </tbody>
       </Table>
       </div>

       <Pagination className="mt-3">
  <Pagination.Prev
    onClick={() => setCurrentPageAssigned(currentPageAssigned - 1)}
    disabled={currentPageAssigned === 1}
  >
    Previous
  </Pagination.Prev>

  {[...Array(totalPagesTasks)].map((_, index) => (
    <Pagination.Item
      key={index}
      active={index + 1 === currentPageAssigned}
      onClick={() => setCurrentPageAssigned(index + 1)}
    >
      {index + 1}
    </Pagination.Item>
  ))}

  <Pagination.Next
    onClick={() => setCurrentPageAssigned(currentPageAssigned + 1)}
    disabled={currentPageAssigned === totalPagesTasks}
  >
    Next
  </Pagination.Next>
</Pagination>


     </Card.Body>
   </Card>
   ) : null}
 </div>
 </Layout>
  );
};

export default ManageTasksScreen;
